export interface Invoices {
  brutto: number,
  city: string,
  comment_phm?: string,
  company_name: string,
  country: string,
  dateI: string,
  dateII: string,
  dateIII: string,
  delivery_id?: number,
  department?: string,
  description: string,
  employee_phm: number,
  job_id?: number,
  name_project: string,
  netto?: number,
  number: string,
  order_id: string,
  paid: number,
  postcode: string,
  praefix: string,
  project_id: string,
  remarks: string,
  request_id: string,
  side_agreements?: string,
  skonto?: number,
  specification?: string,
  status: string,
  street: string,
  vat_id: string,
}

// Rechnungsposition. status, delivery_date, budget und vat_id sind bewusst
// nicht enthalten: die API liefert sie nicht mehr. Sie waren Platzhalter aus
// der Form der uebrigen Positionsantworten -- vat_id gehoert an den
// Rechnungskopf, die drei anderen gibt es fuer Rechnungspositionen nicht.
export interface InvoicesList {
  comment_phm?: string,
  controlling_nr: string,
  description: string,
  heat_nr: string,
  invoice_number: string,
  material: string,
  name: string,
  number_of_pieces: number,
  offer_id: string,
  part: number,
  position: number,
  project_id?: string,
  purchasing_price: string,
  remarks: string,
  selling_price: string,
  serial_nr: string,
  side_agreements?: string,
  specification?: string,
  taric?: string,
  technical_drawing: string,
  technology: boolean,
  weight: string,
}

export interface SingleInvoiceResponse {
  object: SingleInvoice;
  hasErrors: boolean;
  message: string;
  errors: any[];
}

export class SingleInvoice {
  brutto: number = 0;
  city: string = '';
  comment_phm?: string = '';
  company_name: string = '';
  country: string = '';
  dateI: string = '';
  dateII: string = '';
  dateIII: string = '';
  delivery_id?: number = 0;
  department?: string = '';
  description: string = '';
  employee_phm: number = 0;
  job_id?: number = 0;
  name_project: string = '';
  netto?: number = 0;
  number: string = '';
  order_id: string = '';
  paid: number = 0;
  postcode: string = '';
  praefix: string = '';
  project_id: string = '';
  remarks: string = '';
  request_id: string = '';
  side_agreements?: string = '';
  skonto?: number = 0;
  specification?: string = '';
  status: string = '';
  street: string = '';
  vat_id: string = '';
  cancels_invoice_no: string = '';
}

export interface InvoiceForm {
  stepI: StepI;
  stepII: StepII;
  stepIII: StepIII;
}

class StepI {
  praefix: string = '';
  number: string = '';
  project_id: string = '';
  delivery_id?: number = 0;
  job_id?: number = 0;
  company_name: string = '';
  department?: string = '';
  street: string = '';
  city: string = '';
  postcode: string = '';
  country: string = '';
  request_id: string = '';
  order_id: string = '';
  vat_id: string = '';
  employee_phm: number = 0;
  description: string = '';
  name_project: string = '';
  dateI: string = '';
  dateII: string = '';
  status: string = '';
  brutto: number = 0;
  skonto: number = 0;
  paid: number = 0;
}

class StepII {
  employee_phm: string = '';
}

class StepIII {
  employee_leader: string = '';
}

